import React, { useEffect, useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { CircularProgress, Button } from '@material-ui/core';
import { ExpandMore, ExpandLess } from '@material-ui/icons';

/** Components */
import ENotasModal from './components/ENotasModal';
import UneditableInput from '../../components/UneditableInput';
import EditableSelect from '../../components/EditableSelect';
import EditableInput from '../../components/EditableInput';
import AdditionalInformation from '../../components/AdditionalInformation';
import Refund from './../../components/Refund/Refund';

/** Services */
import { getChannels } from '../../services/channel';
import {
  getPayments,
  getTransactionDetails,
  updateTransactionStatus,
  setTransactionId,
  updateTransactionConfirmedStatus,
  updateTransactionWaitingForPayment,
} from '../../services/payment';

/** Helpers */
import { formatCurrency } from '../../helpers/formatCurrency';

/** Actions */
import { showAlert } from '../../store/ducks/alert';

const PaymentsInformation = props => {
  const dispatch = useDispatch();
  const eNotasModalRef = useRef();
  const [payment, setPayment] = useState({});
  const [transactionDetails, setTransactionDetails] = useState([]);
  const [transactionDetailsFormatted, setTransactionDetailsFormatted] = useState([]);
  const [paymentChannel, setPaymentChannel] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [allDetailsOpen, setAllDetailsOpen] = useState(false);
  const [paymentUid, setPaymentUid] = useState(0);
  const [detailsUneditable, setDetailsUneditable] = useState(0);
  const [send, setClickSend] = useState(false);
  const currency = 'BRL'; //TODO temporary

  useEffect(() => {
    displayPayment();
  }, []);

  useEffect(() => {
    if (Object.keys(transactionDetails).length > 0) {
      const details = {
        ...transactionDetails,
        ...transactionDetails.ourData,
        ...transactionDetails.gatewayDetails,
        amount: formatCurrency(currency, Number(transactionDetails?.gatewayDetails?.amount || transactionDetails?.ourData?.value)),
        value: formatCurrency(currency, Number(transactionDetails.ourData.value)),
      };
      delete details.amout;
      delete details.ourData;
      delete details.gatewayDetails;
      setDetailsUneditable(Object.keys(details));
      setTransactionDetailsFormatted(details);
    }
  }, [transactionDetails]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDetails = () => {
    if (!allDetailsOpen) {
      setAllDetailsOpen(true);
    } else setAllDetailsOpen(false);
  };

  const handleSendAlterations = async (uid, status, transactionIdInOrigin, confirmed) => {
    try {
      if (transactionIdInOrigin) await setTransactionId(uid, transactionIdInOrigin);
      if (status) await updateTransactionStatus(uid, status);
      if (typeof confirmed === 'boolean') await updateTransactionConfirmedStatus(uid, confirmed);
      setClickSend(false);
      dispatch(showAlert('success', 'Here we go! 🤘'));
    } catch (error) {
      dispatch(showAlert('error', 'Ops! Something went wrong 😔'));
    }
  };

  const handleConfirmedStatusChange = async () => {
    try {
      if (typeof transactionDetails.confirmed === 'boolean') {
        await updateTransactionConfirmedStatus(transactionDetails.ourData.uid, transactionDetails.confirmed);
      }
      if (typeof transactionDetails.isWaitingForPayment === 'boolean') {
        await updateTransactionWaitingForPayment(transactionDetails.ourData.uid, transactionDetails.isWaitingForPayment);
      }
      if (transactionDetails.status) {
        await updateTransactionStatus(transactionDetails.ourData.uid, transactionDetails.status);
      }
      setClickSend(false);
      dispatch(showAlert('success', 'Here we go! 🤘'));
    } catch (error) {
      dispatch(showAlert('error', 'Ops! Something went wrong 😔'));
    }
  };

  const uneditable = Object.keys(payment);

  const displayPayment = async () => {
    const paymentId = props.match.params.uid;

    try {
      setIsLoading(true);

      const { data } = await getPayments(0, { searchItem: 'uid', search: paymentId });
      const channel = await getChannels(0, { searchItem: 'id', search: data.rows[0].toChannelId });
      const { data: transactionDetailsRes } = await getTransactionDetails(data.rows[0].uid);

      setPayment({
        ...data.rows[0],
        value: formatCurrency(currency, Number(data.rows[0].value)),
      });
      setPaymentChannel(channel.data.rows);
      setPaymentUid(data.rows[0].uid);
      setTransactionDetails(transactionDetailsRes);
      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert('error', 'Ops! We could not load. 😔'));
      console.log(error);
    }
  };

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <section className="update-section">
        <div className="update-section-top">
          <h3>View Payment Properties</h3>
          <div>
            <Button className="modal-btn" variant="contained" color="secondary" onClick={handleOpen} disabled={payment.isCanceled}>
              Refund
            </Button>
          </div>
          {open ? <Refund onClose={handleClose} paymentUid={paymentUid} /> : ''}
        </div>
        <form className="update-form">
          {transactionDetails?.ourData?.paymentType === 'withdraw' && (
            <div>
              <EditableSelect data={transactionDetails} setData={setTransactionDetails} labels={['status']} isStatus />
              <EditableInput data={transactionDetails} setData={setTransactionDetails} labels={['transactionIdInOrigin']} />
              <Button
                className="confirmation-btn"
                onClick={() =>
                  handleSendAlterations(
                    transactionDetails.ourData.uid,
                    transactionDetails.status,
                    transactionDetails.transactionIdInOrigin,
                    transactionDetails.ourData.paymentType
                  )
                }
              >
                Update
              </Button>
            </div>
          )}
          {(transactionDetails?.ourData?.paymentType === 'subscribe_channel' ||
            transactionDetails?.ourData?.paymentType === 'pay_subscription' ||
            transactionDetails?.ourData?.paymentType === 'link') && (
            <div>
              <EditableSelect data={transactionDetails} setData={setTransactionDetails} labels={['confirmed', 'isWaitingForPayment']} />
              <EditableSelect data={transactionDetails} setData={setTransactionDetails} labels={['status']} isStatus />
              <Button className="confirmation-btn" onClick={handleConfirmedStatusChange}>
                Update
              </Button>
            </div>
          )}

          <div className="form-fields">
            <UneditableInput data={payment} labels={uneditable} />
          </div>

          {allDetailsOpen && (
            <>
              <h3>All Details</h3>

              <UneditableInput data={transactionDetailsFormatted} labels={detailsUneditable} />
            </>
          )}
          <Button
            className="update-btn"
            startIcon={!allDetailsOpen ? <ExpandMore /> : <ExpandLess />}
            onClick={handleDetails}
            variant="contained"
          >
            See all Information
          </Button>
        </form>
      </section>
      {paymentChannel[0] && (
        <section className="additional-section">
          <h3>Channel</h3>
          <AdditionalInformation data={paymentChannel} dataKey="name" path="channels" useUid={true} />
        </section>
      )}

      <ENotasModal ref={eNotasModalRef} transaction={transactionDetails} />
    </>
  );
};

export default PaymentsInformation;
